module.exports = __webpack_public_path__ + "28.4490fc9d.png";